import * as actionTypes from '../types/metric';

export function metricPieceData(payload) {
  return {
    type: actionTypes.METRIC_PIECE_DATA,
    payload
  };
}
export function metricPieceDataSuccess(payload) {
  return {
    type: actionTypes.METRIC_PIECE_DATA_SUCCESS,
    payload
  };
}
export function metricPieceDataFail(payload) {
  return {
    type: actionTypes.METRIC_PIECE_DATA_FAIL,
    payload
  };
}

export function metricPieceDataAll(payload) {
  return {
    type: actionTypes.METRIC_PIECE_DATA_ALL,
    payload
  };
}
export function metricPieceDataAllSuccess(payload) {
  return {
    type: actionTypes.METRIC_PIECE_DATA_ALL_SUCCESS,
    payload
  };
}
export function metricPieceDataAllFail(payload) {
  return {
    type: actionTypes.METRIC_PIECE_DATA_ALL_FAIL,
    payload
  };
}

export function metricPieceTypesList(payload) {
  return {
    type: actionTypes.METRIC_PIECE_TYPES_LIST,
    payload
  };
}
export function metricPieceTypesListSuccess(payload) {
  return {
    type: actionTypes.METRIC_PIECE_TYPES_LIST_SUCCESS,
    payload
  };
}
export function metricPieceTypesListFail(payload) {
  return {
    type: actionTypes.METRIC_PIECE_TYPES_LIST_FAIL,
    payload
  };
}

export function metricUserActivityShort(payload) {
  return {
    type: actionTypes.METRIC_USER_ACTIVITY_SHORT,
    payload
  };
}
export function metricUserActivityShortSuccess(payload) {
  return {
    type: actionTypes.METRIC_USER_ACTIVITY_SHORT_SUCCESS,
    payload
  };
}
export function metricUserActivityShortFail(payload) {
  return {
    type: actionTypes.METRIC_USER_ACTIVITY_SHORT_FAIL,
    payload
  };
}

export function metricUserActivityDetailed(payload) {
  return {
    type: actionTypes.METRIC_USER_ACTIVITY_DETAILED,
    payload
  };
}
export function metricUserActivityDetailedSuccess(payload) {
  return {
    type: actionTypes.METRIC_USER_ACTIVITY_DETAILED_SUCCESS,
    payload
  };
}
export function metricUserActivityDetailedFail(payload) {
  return {
    type: actionTypes.METRIC_USER_ACTIVITY_DETAILED_FAIL,
    payload
  };
}
export function metricAddedStocks(payload) {
  return {
    type: actionTypes.METRIC_ADDED_STOCKS,
    payload
  };
}
export function metricAddedStocksSuccess(payload) {
  return {
    type: actionTypes.METRIC_ADDED_STOCKS_SUCCESS,
    payload
  };
}
export function metricAddedStocksFail(payload) {
  return {
    type: actionTypes.METRIC_ADDED_STOCKS_FAIL,
    payload
  };
}
